import Api from '../Api';

import { url } from './config';
import { Language } from './types';

const api = new Api<Language>(url);

export default api;
